var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTxHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1C7.35517 1 4.98618 2.15745 3.33654 3.98017L1 1.64363V6.53846H5.89483L4.3155 4.95913C5.71094 3.38522 7.72837 2.38462 10 2.38462C14.2133 2.38462 17.6154 5.78666 17.6154 10C17.6154 14.2133 14.2133 17.6154 10 17.6154C5.78666 17.6154 2.38462 14.2133 2.38462 10V9.30769H1V10C1 14.9651 5.03486 19 10 19C14.9651 19 19 14.9651 19 10C19 5.03486 14.9651 1 10 1ZM9.30769 3.76923V10.6923H13.4615V9.30769H10.6923V3.76923H9.30769Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxHistory);
export default __webpack_public_path__ + "static/media/tx-history.53b5c71b4fb8fd799af3ba8db6ad8b0b.svg";
export { ForwardRef as ReactComponent };